import { supabase } from "./supabaseClient";

export const profilesRepository = {
  getByUserId: (userId: string) =>
    supabase
      .from("profiles")
      .select(
        `
        id,
        full_name,
        tenant_id,
        tenants:tenant_id (
          id,
          name,
          cnpj,
          email,
          phone,
          onboarding_completed_at,
          portal_code
        )
      `
      )
      .eq("user_id", userId)
      .maybeSingle(),
};

const ALLOWED_TENANT_FIELDS = new Set([
  "name", "cnpj", "cpf", "responsible_name", "email", "phone", "logo_url",
  "checkout_primary_color", "allow_checkout_add_items", "allow_checkout_remove_items",
  "retirada_loja_enabled", "pagamento_retirada_enabled",
  "checkout_gatilhos", "checkout_expiration_config",
  "hold_checkout_links", "onboarding_completed_at",
  "instagram_auto_reply_enabled", "dm_template_new_order", "dm_template_item_added",
  "shipping_methods",
  "frete_gratis_enabled", "frete_fixo_enabled", "frete_fixo_values",
  "entrega_local_enabled", "embalagem_padrao",
  "commercial_conditions",
]);

export const tenantSettingsRepository = {
  getByProfileUserId: (userId: string) =>
    supabase
      .from("profiles")
      .select("tenant_id")
      .eq("user_id", userId)
      .single(),

  get: (tenantId: string) =>
    supabase
      .from("tenants")
      .select("*")
      .eq("id", tenantId)
      .single(),

  update: (tenantId: string, data: Record<string, unknown>) => {
    const safe = Object.fromEntries(
      Object.entries(data).filter(([k]) => ALLOWED_TENANT_FIELDS.has(k))
    );
    return supabase.from("tenants").update(safe).eq("id", tenantId);
  },
};

export const storeAddressesRepository = {
  list: (tenantId: string) =>
    supabase
      .from("store_addresses")
      .select("*")
      .eq("tenant_id", tenantId)
      .order("created_at", { ascending: true }),

  create: (tenantId: string, data: Record<string, unknown>) =>
    supabase
      .from("store_addresses")
      .insert({ ...data, tenant_id: tenantId }),

  update: (tenantId: string, id: string, data: Record<string, unknown>) =>
    supabase.from("store_addresses").update(data).eq("tenant_id", tenantId).eq("id", id),

  delete: (tenantId: string, id: string) =>
    supabase.from("store_addresses").delete().eq("tenant_id", tenantId).eq("id", id),
};

export const localRegionsRepository = {
  list: (tenantId: string) =>
    supabase
      .from("shipping_local_regions")
      .select("*")
      .eq("tenant_id", tenantId)
      .order("created_at", { ascending: true }),

  create: (tenantId: string, data: Record<string, unknown>) =>
    supabase
      .from("shipping_local_regions")
      .insert({ ...data, tenant_id: tenantId }),

  update: (tenantId: string, id: string, data: Record<string, unknown>) =>
    supabase.from("shipping_local_regions").update(data).eq("tenant_id", tenantId).eq("id", id),

  delete: (tenantId: string, id: string) =>
    supabase.from("shipping_local_regions").delete().eq("tenant_id", tenantId).eq("id", id),
};

export const subscriptionStatusRepository = {
  getTenantActive: (tenantId: string) =>
    supabase
      .from("tenants")
      .select("is_active")
      .eq("id", tenantId)
      .single(),

  getSubscription: (tenantId: string) =>
    supabase
      .from("subscriptions")
      .select("id, status, expires_at")
      .eq("tenant_id", tenantId)
      .maybeSingle(),
};

